import React from 'react';
import { useState, useContext } from 'react';
import style from './FirebaseAuthHandler.module.css';

import Lottie from 'lottie-react';
import check_animation from '../../lottieAnimations/checkmark.json';
import warning_animation from '../../lottieAnimations/warning_animation.json';
import verification_animation from '../../lottieAnimations/verification_animation.json';
import icons from '../../icons';

import { auth } from '../../firebase';
import { applyActionCode, checkActionCode, confirmPasswordReset, sendEmailVerification, signInWithEmailAndPassword, verifyPasswordResetCode } from "firebase/auth";
import { AppContext } from '../../AppContext';
import urls from '../../urls';


const FirebaseAuthHandler = () => {
    const { user } = useContext(AppContext);

    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [passwordError, setPasswordError] = useState({ hideError: true, error: undefined });

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const actionCode = urlParams.get("oobCode");

    const getErrorMessage = code => {
        switch (code.replace("auth/", "")) {
            case "user-not-found":
                return "Nessun utente trovato per questo account";
            case "too-many-requests":
                return "Hai eseguito troppe richieste da questo dispositivo. Attendi.";
            case "wrong-password":
                return "La password non è corretta, o l'account è registrato con Google";
            case "invalid-email":
                return "L'indirizzo email inserito non è valido";
            case "email-already-in-use":
                return "Questo indirizzo email è già associato a un altro account";
            case "weak-password":
                return "La password dev'essere lunga almeno 6 caratteri";
            default: 
                return "Qualcosa non ha funzionato, riprova più tardi";
        }
    }

    switch (urlParams.get("mode")) {
        case "fallbackVerifyEmail":
            return <main className={ style.main }>
                <Lottie 
                    style={{ backgroundColor: "rgb(44, 44, 44)" }}
                    loop={ false }
                    autoplay={ true }
                    animationData={ check_animation }
                    speed={ 0.1 }
                    delay={ 5000 }
                    height={ 300 }
                    width={ 300 }
                />
                <h3 style={{ textAlign: "center", fontSize: "1rem", marginTop: "4rem" }}>Clicca "Continua" per completare la verifica dell'email</h3>
                <div className={ style.button } onClick={ () => {
                    if (!auth.currentUser)
                        return;

                    setLoading(true);
                    fetch(urls.fallbackEmailVerification, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            userId: auth.currentUser.uid
                        })
                    }).then(res => {
                        if (res.ok)
                            window.location.href = "/";
                    });
                } }>
                    { (loading || !auth.currentUser) ? 
                        <div className={ style.spinner }></div> : 
                        <>
                            <img alt="" src={ icons.check_icon } />
                            <h3>CONTINUA</h3>
                        </> 
                    }
                </div> 
            </main>;
        case "verifyAndChangeEmail":
            if (!error)
                return (
                    <main className={ style.main }>
                        <Lottie 
                            style={{ backgroundColor: "rgb(44, 44, 44)" }}
                            loop={ false }
                            autoplay={ true }
                            animationData={ check_animation }
                            speed={ 0.1 }
                            delay={ 5000 }
                            height={ 300 }
                            width={ 300 }
                        />
                        <h3 style={{ textAlign: "center", fontSize: "1rem", marginTop: "4rem" }}>Clicca "Continua" per completare la verifica dell'email</h3>
                        <div className={ style.button } onClick={ () => {
                            setLoading(true);
                            applyActionCode(auth, actionCode)
                                .then(() => {
                                    window.location.href = "/";
                                }).catch(error => {
                                    console.warn(`Error verifying email address: ${error}`);
                                    setPasswordError({ hideError: true, error: undefined });
                                    setNewPassword("");
                                    setError(true);
                                    setLoading(false);
                                });
                        } }>
                            { loading ? 
                                <div className={ style.spinner }></div> : 
                                <>
                                    <img alt="" src={ icons.check_icon } />
                                    <h3>CONTINUA</h3>
                                </> 
                            }
                        </div> 
                    </main>
                );

            return (
                <main className={ style.main }>
                    <Lottie 
                        style={{ backgroundColor: "rgb(44, 44, 44)" }}
                        loop={ false }
                        autoplay={ true }
                        animationData={ warning_animation }
                        speed={ 0.1 }
                        delay={ 5000 }
                        height={ 300 }
                        width={ 300 }
                    />
                    <h3 style={{ textAlign: "center", fontSize: "1rem", marginTop: "4rem" }}>Qualcosa non ha funzionato</h3>
                    <div className={ [style.button, style.orangeBackground].join(" ") } onClick={ async () => {
                        if (loading) 
                            return;

                        setLoading(true);
                        await sendEmailVerification(auth.currentUser);
                        window.location.href = "/emailVerification";
                    } } >
                        { loading ? 
                            <div className={ style.spinner }></div> : 
                            <>
                                <img alt="" src={ icons.email_icon } />
                                <h3>VERIFICA EMAIL</h3>
                            </> 
                        }
                    </div> 
                </main>
            );

        case "verifyEmail":
            if (!error)
                return (
                    <main className={ style.main }>
                        <Lottie 
                            style={{ backgroundColor: "rgb(44, 44, 44)" }}
                            loop={ false }
                            autoplay={ true }
                            animationData={ check_animation }
                            speed={ 0.1 }
                            delay={ 5000 }
                            height={ 300 }
                            width={ 300 }
                        />
                        <h3 style={{ textAlign: "center", fontSize: "1rem", marginTop: "4rem" }}>Clicca "Continua" per completare la verifica dell'email</h3>
                        <div className={ style.button } onClick={ () => {
                            setLoading(true);
                            applyActionCode(auth, actionCode)
                                .then(() => {
                                    window.location.href = "/";
                                }).catch(error => {
                                    console.warn(`Error verifying email address: ${error}`);
                                    setPasswordError({ hideError: true, error: undefined });
                                    setNewPassword("");
                                    setError(true);
                                    setLoading(false);
                                });
                        } }>
                            { loading ? 
                                <div className={ style.spinner }></div> : 
                                <>
                                    <img alt="" src={ icons.check_icon } />
                                    <h3>CONTINUA</h3>
                                </> 
                            }
                        </div> 
                    </main>
                );

            return (
                <main className={ style.main }>
                    <Lottie 
                        style={{ backgroundColor: "rgb(44, 44, 44)" }}                        
                        loop={ false }
                        autoplay={ true }
                        animationData={ warning_animation }
                        speed={ 0.1 }
                        delay={ 5000 }
                        height={ 300 }
                        width={ 300 }
                    />
                    <h3 style={{ textAlign: "center", fontSize: "1rem", marginTop: "4rem" }}>Qualcosa non ha funzionato</h3>
                    <div className={ [style.button, style.orangeBackground].join(" ") } onClick={ async () => {
                        if (loading) 
                            return;

                        setLoading(true);
                        await sendEmailVerification(auth.currentUser);
                        window.location.href = "/emailVerification";
                    } } >
                        { loading ? 
                            <div className={ style.spinner }></div> : 
                            <>
                                <img alt="" src={ icons.email_icon } />
                                <h3>VERIFICA EMAIL</h3>
                            </> 
                        }
                    </div> 
                </main>
            );

        case "recoverEmail":
            if (!error)
                return (
                    <main className={ style.main }>
                        <Lottie 
                            style={{ backgroundColor: "rgb(44, 44, 44)" }}
                            loop={ false }
                            autoplay={ true }
                            animationData={ check_animation }
                            speed={ 0.1 }
                            delay={ 5000 }
                            height={ 300 }
                            width={ 300 }
                        />
                        <h3 style={{ textAlign: "center", fontSize: "1rem", marginTop: "4rem" }}>Clicca "Continua" per reimpostare l'indirizzo email</h3>
                        <div className={ style.button } onClick={ () => {
                            setLoading(true);
                            checkActionCode(auth, actionCode).then(() => {
                                setLoading(true);
                                return applyActionCode(auth, actionCode);
                            }).then(() => {
                                window.location.href = "/";
                            }).catch(error => {
                                console.warn(`Error recovering email address: ${error}`);
                                setPasswordError({ hideError: true, error: undefined });
                                setNewPassword("");
                                setError(true);
                                setLoading(false);
                            });
                        } }>
                            { loading ? 
                                <div className={ style.spinner }></div> : 
                                <>
                                    <img alt="" src={ icons.check_icon } />
                                    <h3>CONTINUA</h3>
                                </> 
                            }
                        </div> 
                    </main>
                );

            return (
                <main className={ style.main }>
                    <Lottie 
                        style={{ backgroundColor: "rgb(44, 44, 44)" }}                        
                        loop={ false }
                        autoplay={ true }
                        animationData={ warning_animation }
                        speed={ 0.1 }
                        delay={ 5000 }
                        height={ 300 }
                        width={ 300 }
                    />
                    <h3 style={{ textAlign: "center", fontSize: "1rem", marginTop: "4rem" }}>Qualcosa non ha funzionato</h3>
                    <div className={ [style.button, style.orangeBackground].join(" ") } onClick={ () => window.location.href = "/" } >
                        <img alt="" src={ icons.home_icon } />
                        <h3>TORNA ALLA HOME</h3>
                    </div> 
                </main>
            );

        case "resetPassword":
            if (!error)
                return (
                    <main className={ style.main }>
                        <div className={ style.error } style={{
                            opacity: passwordError.error ? "1" : "0",
                            display: passwordError.hideError ? "none" : "flex"
                        }}>
                            <img alt="" src={ icons.warning_icon }></img>
                            <h4>{ passwordError.error }</h4>
                        </div>
                        <Lottie 
                            style={{ backgroundColor: "rgb(44, 44, 44)", marginTop: "1rem" }}
                            loop={ false }
                            autoplay={ true }
                            animationData={ verification_animation }
                            speed={ 0.1 }
                            delay={ 5000 }
                            height={ 300 }
                            width={ 300 }
                        />
                        <div className={ style.loginItem }>
                            <img alt="" src={ icons.lock_icon } />
                            <input placeholder="Nuova password" type="password" value={ newPassword } onChange={ (event) => {
                                setNewPassword(event.target.value)
                            } }></input>
                        </div>
                        <div className={ [style.button, style.orangeBackground].join(" ") } onClick={ () => {
                            setLoading(true);
                            verifyPasswordResetCode(auth, actionCode).then(email => {
                                confirmPasswordReset(auth, actionCode, newPassword).then(async () => {
                                    await signInWithEmailAndPassword(auth, email, newPassword);
                                    window.location.href = "/";
                                }).catch(error => {
                                    setPasswordError({ error: getErrorMessage(error.code), hideError: false });
                                    setLoading(false);
                                    setTimeout(() => {
                                        setPasswordError({ ...error, error: undefined });
                                        setTimeout(() => {
                                            setPasswordError({ ...error, hideError: true });
                                        }, 1000);
                                    }, 3000);
                                });
                            }).catch(error => {
                                console.warn(`Error resetting password: ${error}`);
                                setPasswordError({ hideError: true, error: undefined });
                                setNewPassword("");
                                setError(true);
                                setLoading(false);
                            });
                        } }>
                            { loading ? 
                                <div className={ style.spinner }></div> : 
                                <>
                                    <img alt="" src={ icons.lock_white_icon } />
                                    <h3>MODIFICA PASSWORD</h3>
                                </> 
                            }
                        </div> 
                    </main>
                );

            return (
                <main className={ style.main }>
                    <Lottie 
                        style={{ backgroundColor: "rgb(44, 44, 44)" }}
                        loop={ false }
                        autoplay={ true }
                        animationData={ warning_animation }
                        speed={ 0.1 }
                        delay={ 5000 }
                        height={ 300 }
                        width={ 300 }
                    />
                    <h3 style={{ textAlign: "center", fontSize: "1rem", marginTop: "4rem" }}>Qualcosa non ha funzionato</h3>
                    <div className={ [style.button, style.orangeBackground].join(" ") } onClick={ () => window.location.href = "/" } >
                        <img alt="" src={ icons.home_icon } />
                        <h3>TORNA ALLA HOME</h3>
                    </div> 
                </main>
            );
                }
    return <main>

    </main>;
}

export default FirebaseAuthHandler;
